import { Avatar } from 'src/app/project-config/components/project-edit-form/models/avatar.model';
import { AvatarApiError } from './avatar.errors';
import { createAction, props } from '@ngrx/store';

export const LoadAvatars = createAction('[Avatar] Load Avatars');

export const LoadAvatarsSuccess = createAction(
  '[Avatar] Avatars Loaded Success',
  props<{ avatars: Avatar[] }>(),
);

export const SetLoadAvatarsError = createAction(
  '[Avatar] Set Load Avatars Error',
  props<{ error: AvatarApiError }>(),
);

export const RemoveAvatarsError = createAction('[Avatar] Remove Avatars Error');
